<div class="request-sent-container">

  <div class="request-sent-title">

    <div class="request-sent-title-icon">
      <i class="icon-check"></i>
    </div>
    
    <h2>{{ 'request_v2.request-sent.title' | translate }}</h2>


  </div>
  
  <div class="request-card">
    <div class="request-details">

    <div class="request-details-header">
      <div class="request-icon">
        <i class="icon-construction"></i>
      </div>
      <div class="request-titles">
        <h3 class="request-category">{{requestCategory}}</h3>
        <h3 *ngIf="requestSubcategory" class="request-subcategory">{{requestSubcategory}}</h3>
      </div>
    </div>

      <p class="request-id">{{ 'request_v2.request-sent.request-card.request-id' | translate }} {{requestId}}</p>

    </div>
  </div>

  <button class="close-button" (click)="onClose()" >
    {{ 'request_v2.create-request-dialog.close-button' | translate }}
</button>
</div>
